module.exports = __webpack_public_path__ + "img/2353c9137d44a5835093af830284aeb.b8e08810.png";